import type { ReactElement } from 'react';

import styles from './ServersChevron.module.css';

/**
 * Перенос `_ServersChevron` из `base_url_page.dart`.
 *
 * Шеврон в поле адреса: раскрывает список запомненных серверов.
 */

/**
 * `Icons.expand_less` и `Icons.expand_more`.
 *
 * Material-иконок в вебе нет (в проекте только свои SVG из `AppIcons`),
 * поэтому оба контура перерисованы из Material-набора на сетке 24×24.
 */
const EXPAND_LESS_PATH = 'M12 8l-6 6 1.41 1.41L12 10.83l4.58 4.58L18 14z';
const EXPAND_MORE_PATH = 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z';

/** `Icon(..., size: 24)` */
const CHEVRON_SIZE = 24;

/** Сетка, в которой нарисованы Material-иконки. */
const ICON_VIEW_BOX = '0 0 24 24';

export interface ServersChevronProps {
  readonly expanded: boolean;
  readonly onTap: () => void;
}

export function ServersChevron({ expanded, onTap }: ServersChevronProps): ReactElement {
  return (
    <div className={styles.root}>
      <button
        type="button"
        data-testid="known-servers-chevron"
        className={styles.chip}
        onClick={onTap}
      >
        <svg
          className={styles.icon}
          width={CHEVRON_SIZE}
          height={CHEVRON_SIZE}
          viewBox={ICON_VIEW_BOX}
          aria-hidden="true"
          focusable="false"
        >
          <path d={expanded ? EXPAND_LESS_PATH : EXPAND_MORE_PATH} fill="currentColor" />
        </svg>
      </button>
    </div>
  );
}
